/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActingAsResponseViewModel
 */
export interface ActingAsResponseViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof ActingAsResponseViewModel
     */
    allowedToActAs: boolean;
    /**
     * 
     * @type {string}
     * @memberof ActingAsResponseViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ActingAsResponseViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof ActingAsResponseViewModel
     */
    email: string;
}

/**
 * Check if a given object implements the ActingAsResponseViewModel interface.
 */
export function instanceOfActingAsResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allowedToActAs" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ActingAsResponseViewModelFromJSON(json: any): ActingAsResponseViewModel {
    return ActingAsResponseViewModelFromJSONTyped(json, false);
}

export function ActingAsResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActingAsResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedToActAs': json['AllowedToActAs'],
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'email': json['Email'],
    };
}

export function ActingAsResponseViewModelToJSON(value?: ActingAsResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AllowedToActAs': value.allowedToActAs,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'Email': value.email,
    };
}

